<template>
    <div
            class="error-player player"
    >
        {{$t('player.not_supported')}}
    </div>
</template>
<script>
    export default {
        props: {
            data: {
                type: Object,
                required: true,
            }
        },
        created(){

        }
    }
</script>

<style scoped lang="scss">
    @import '../styles/variables';

    .player{
        width: 100%;
        min-height: 500px;
        background-color: var(--pallete_secondary_color);
        display: flex;
        align-items: center;
        justify-content: center;

        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }
</style>